import React from "react";
import { Link } from "react-router-dom";

import lawyerHandshake from "./images/3.png";
import lawyerHandshake2 from "./images/4.png";
import lawyerHandshake3 from "./images/5.png";
import lawyerHandshake4 from "./images/6.png";

import "./Legal_Consequences.css";

const cases = [
  {
    number: "01",
    title: "צו הגנה לאישה מבוגרת בת 80",
    category: "צווי הגנה",
    description: (
      <>
        <p>
          אישה כבת 80, אשר התקשתה להתמודד עם התנהלותו של בנה בן ה־45,
          פנתה לקבלת סיוע משפטי לאחר שבנה, שהיה חסר קורת גג, נהג להגיע
          לביתה ולהטריד אותה. הבן ניסה להיכנס לדירתה, וכאשר הצליח להיכנס,
          היה נשאר בבית ומסרב לעזוב, תוך שהוא מקשה עליה לנהל את שגרת
          חייה בביתה שלה.
        </p>

        <p>
          למרות שהאם פנתה למשטרה והגישה תלונה, היא לא קיבלה את המענה
          לו נזקקה, והופנתה להגיש בקשה לקבלת צו הגנה בבית המשפט לענייני
          משפחה.
        </p>

        <p>
          בעקבות הפנייה לבית המשפט, ולאחר הצגת נסיבות המקרה, נעתר
          בית המשפט לבקשה והורה על מתן צו הגנה שנועד להרחיק את הבן
          מאמו ולהגן על ביטחונה ועל שלוות חייה.
        </p>
      </>
    ),
    result:
      "בית המשפט הורה על מתן צו הגנה שנועד להרחיק את הבן מאמו ולהגן על ביטחונה ועל שלוות חייה.",
    images: [
      {
        src: lawyerHandshake,
        alt: "פגישת ייעוץ משפטית"
      },
      {
        src: lawyerHandshake3,
        alt: "ליווי וייצוג משפטי"
      }
    ]
  },
  {
    number: "02",
    title: "מינוי אפוטרופוס לאם מבוגרת",
    category: "אפוטרופסות",
    description: (
      <p>
        ייצוג בן שביקש להתמנות כאפוטרופוס לאמו, אישה כבת 80. הבקשה
        נתקלה בהתנגדות מצד ארבע אחיותיו, אשר העלו חששות בנוגע
        לניהול ענייניה ורכושה של האם.
      </p>
    ),
    result:
      "במסגרת ההליך הוצגו טענות וראיות לתמיכה בבקשה ולהוכחת טובת האם. לפי המידע שנמסר, בית המשפט קיבל את הבקשה והורה על מינוי הבן כאפוטרופוס.",
    images: [
      {
        src: lawyerHandshake2,
        alt: "ליווי משפטי אישי"
      },
      {
        src: lawyerHandshake4,
        alt: "ייצוג משפטי"
      }
    ]
  }
];

const Legal_Consequences = () => {
  return (
    <main className="landing-container" dir="rtl">
      <div className="background-overlay" aria-hidden="true" />

      <div className="content-wrapper">
        <header className="landing-header">
          <h1 className="main-heading">
            ייצוג משפטי מקצועי
            <span className="heading-highlight">
              עם ניסיון של למעלה מ־24 שנים
            </span>
          </h1>

          <h2 className="secondary-heading">
            ליווי משפטי אישי בתחומי דיני המשפחה,
            <br className="desktop-break" />
            הגירושין והעניינים המשפטיים הנלווים
          </h2>

          <p className="description-paragraph">
            משרד עורכי הדין רז יוסף מעניק ייעוץ, ליווי וייצוג משפטי
            תוך הקפדה על מקצועיות, יסודיות, דיסקרטיות ויחס אישי.
            כל מקרה נבחן באופן פרטני, תוך התייחסות לנסיבותיו
            ולזכויות המשפטיות הרלוונטיות.
          </p>

          <p className="promise-text">
            כל תיק זוכה להתייחסות אישית, לבחינה משפטית מעמיקה
            ולבניית דרך פעולה המתאימה לנסיבות המקרה
          </p>
        </header>

        <section
          className="selected-cases"
          aria-labelledby="cases-title"
        >
          <div className="cases-heading">
            <h2 id="cases-title">
              תיקים אקראיים ותוצאות משפטיות
            </h2>

            <p>
              דוגמאות להליכים משפטיים שבהם ייצג משרד עורך הדין
              רז יוסף את לקוחותיו
            </p>

            <span className="cases-heading-line" />
          </div>

          <div className="cases-grid">
            {cases.map((caseItem) => (
              <article
                className="case-card"
                key={caseItem.number}
              >
                <div className="case-card-header">
                  <div className="case-card-meta">
                    <span className="case-number">
                      תיק {caseItem.number}
                    </span>

                    <span className="case-category">
                      {caseItem.category}
                    </span>
                  </div>

                  <h3>{caseItem.title}</h3>
                </div>

                <div className="case-description">
                  <h4>
                    <span className="case-section-number">01</span>
                    רקע המקרה
                  </h4>

                  <div className="case-description-content">
                    {caseItem.description}
                  </div>
                </div>

                <div className="case-result">
                  <h4>
                    <span className="case-section-number">02</span>
                    תוצאת ההליך
                  </h4>

                  <p>{caseItem.result}</p>
                </div>

                <div className="case-media-section">
                  <div className="case-media-heading">
                    <div>
                      <h4>תמונות מהתיק</h4>
                    </div>
                  </div>

                  <div className="case-media-grid">
                    {caseItem.images.map((image, index) => (
                      <div
                        className="case-photo-container"
                        key={`${caseItem.number}-${index}`}
                      >
                        <img
                          src={image.src}
                          alt={image.alt}
                          className="case-photo"
                          loading="lazy"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="cases-disclaimer">
            <span className="disclaimer-icon">ⓘ</span>

            <p>
              הצגת המקרים נעשית תוך שמירה על פרטיות המעורבים.
              פרסום מסמכים ותמונות ייעשה בכפוף לדין ולהיתרים הנדרשים.
            </p>
          </div>
        </section>

        <section className="call-to-action-section">
          <h2 className="cta-highlight">
            זקוקים לייעוץ או לייצוג משפטי?
          </h2>

          <p className="cta-description">
            משרד עורכי הדין רז יוסף עומד לרשותכם
            לליווי משפטי מקצועי, אישי ודיסקרטי.
          </p>

          <div className="landing-actions">
            <Link
              to="/ContactSection2"
              className="cta-button"
            >
              <span>לתיאום פגישת ייעוץ</span>
              <span className="cta-arrow">←</span>
            </Link>
          </div>
        </section>

        <section className="landing-page1" dir="rtl">
          <div className="landing-page1-hero">
            <div className="landing-page1-hero-content">
              <h2>
                <span>מקצועיות. ניסיון. ליווי אישי.</span>
              </h2>

              <p>
                משרד עורכי הדין רז יוסף מעניק ייעוץ, ליווי וייצוג משפטי
                במגוון תחומי דיני המשפחה, ובהם הליכי גירושין, חלוקת רכוש
                ואיזון משאבים, אחריות הורית וזמני שהות, מזונות ילדים
                ומזונות אישה, ענייני בית הדין הרבני, הסכמי גירושין וגישור,
                צווים דחופים והליכי הגנה, מרוץ הסמכויות וגירושין בינלאומיים.
                המשרד עוסק גם בנישואין אזרחיים ופסולי חיתון, תביעות נזיקין
                בין בני זוג, יחסי ממון וצוואות בגירושין, אפוטרופסות וניכור
                הורי, ידועים בציבור ותאים משפחתיים חלופיים וכן ייפוי כוח
                מתמשך.
              </p>
            </div>
          </div>

          <div className="landing-page1-content">
            <div className="landing-page1-content-inner">
              <p className="landing-page1-highlight">
                בכל הליך משפטי חשוב שיהיה לצדכם ליווי מקצועי,
                הקשבה אמיתית, דיסקרטיות ומחויבות לבחינת האפשרויות
                המשפטיות העומדות לרשותכם. משרד עורכי הדין רז יוסף
                מעניק לכל לקוח יחס אישי ובחינה יסודית של נסיבות המקרה.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Legal_Consequences;